import { useState } from "react";

import SettingsIcon from "~/common/components/icons/SettingsIcon";
import { ConsultationLinkResponse } from "~/providers/types/invitations";
import { OrganizationProvidersResponse } from "~/providers/types/teamMembers";
import { UpsertConsultationLinkModal } from "./UpsertConsultationLinkModal";

interface UpdateConsultationLinkModalProps {
  link: ConsultationLinkResponse;
  providers: OrganizationProvidersResponse[];
}

export const UpdateConsultationLinkModal = ({
  link,
  providers,
}: UpdateConsultationLinkModalProps) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <button
        className="flex items-center justify-center disabled:cursor-not-allowed disabled:text-neutral-400"
        disabled={!link.is_active}
        onClick={() => setShow(true)}
      >
        <SettingsIcon className="w-5 stroke-2" />
      </button>
      <UpsertConsultationLinkModal
        link={link}
        providers={providers}
        show={show}
        onClose={() => setShow(false)}
      />
    </div>
  );
};
